export function upperCaseFilter(value: string): string {

    if(value === null){
        return null;
    }

    return value ? value.toUpperCase() : ''
}